// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__0BfNA","pickupDisplayLayout":"AppLayout_pickupDisplayLayout__aWIls"};